import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFloorFilterAction } from '../actions/mvk_state';
import { FloorFilter } from '../components/floor_filter';
import { getFlatsInSectionFloor } from '../utils/parsers/flats';
import { getFloorsInSection } from '../utils/parsers/sections';
function mapStateToProps(state) {
  var MVKData = state.MVKData,
    MVKState = state.MVKState;
  var housId = MVKState.house.id;
  var sectionId = MVKState.section.id;
  var floors = getFloorsInSection(MVKData, housId, sectionId);
  var floorsWithFlats = floors.filter(function (floor) {
    return getFlatsInSectionFloor(MVKData, housId, sectionId, floor).length;
  });
  return {
    floors: floors.reverse(),
    floorsWithFlats: floorsWithFlats,
    selectedFloor: MVKState.sectionPhaseFilters.selectedFloor,
    isOfferCard: MVKState.isOfferCard
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setFloor: bindActionCreators(setFloorFilterAction, dispatch)
  };
}
export var FloorFilterContainer = connect(mapStateToProps, mapDispatchToProps)(FloorFilter);